module.exports = __webpack_public_path__ + "img/graph.e6acab30.svg";